import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {WeeeSystems} from '../../../models/weee_systems.interface';
import {UsersService} from '../../../services/users.service';
import {User} from '../../../../kf-data-entry/models/user.interface';
import {Role} from '../../../models/role.interface';

@Component({
  selector: 'app-edit-users',
  templateUrl: './edit-users.component.html',
  styleUrls: ['./edit-users.component.scss']
})
export class EditUsersComponent implements OnInit {

  userEditForm = this.formBuilder.group({
    firstName: [''],
    name: ['', Validators.required],
    email: ['', Validators.required],
    function: [null],
    role: ['', Validators.required],
    weeeSystem: ['', Validators.required],
  });

  get firstNameControl(): FormControl {
    return this.userEditForm.get('firstName') as FormControl;
  }
  get nameControl(): FormControl {
    return this.userEditForm.get('name') as FormControl;
  }
  get emailControl(): FormControl {
    return this.userEditForm.get('email') as FormControl;
  }
  get functionControl(): FormControl {
    return this.userEditForm.get('function') as FormControl;
  }
  get weeeSystemControl(): FormControl {
    return this.userEditForm.get('weeeSystem') as FormControl;
  }
  get roleControl(): FormControl {
    return this.userEditForm.get('role') as FormControl;
  }

  @Output()
  editEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(private dialogRef: MatDialogRef<EditUsersComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {user: User, weeeSystems: WeeeSystems[], roles: Role[]},
              private readonly formBuilder: FormBuilder,
              private readonly usersService: UsersService) { }

  ngOnInit(): void {
    this.nameControl.setValue(this.data.user.name);
    this.emailControl.setValue(this.data.user.email);
    this.roleControl.setValue(this.data.user.role.code);
    if (this.data.user.weeeSystem?.id) {
      this.weeeSystemControl.setValue(this.data.user.weeeSystem.id);
    }
    if (this.data.user.firstName) {
      this.firstNameControl.setValue(this.data.user.firstName);
    }
    if (this.data.user.userFunction) {
      this.functionControl.setValue(this.data.user.userFunction);
    }

  }

  sendEditionForm(): void {
    const dto: User | null = this.getEditionForm();
    if (dto) {
      this.usersService.editUser(dto).subscribe(
        () => {
          this.editEvent.emit();
          this.closeDialog();
        },
        () => {
          this.closeDialog();
        }
      );
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private getEditionForm(): User {
    let role: Role =  {code: '', description: '', id: 0, name: ''};
    this.data.roles.forEach(r => {
      if (this.roleControl.value === r.code) {
        role = r;
      }
    });
    let weeeSystem: WeeeSystems = {country: {code: '', name: ''}, description: ''};
    this.data.weeeSystems.forEach(ws => {
      if (ws.id === this.weeeSystemControl.value) {
        weeeSystem = ws;
      }
    });
    return {
      id: this.data.user.id,
      phone: this.data.user.phone,
      email: this.emailControl.value,
      name: this.nameControl.value,
      firstName: this.firstNameControl.value,
      userFunction: this.functionControl.value,
      role,
      weeeSystem: this.roleControl.value !== 'WF_ADMIN' ? weeeSystem as any : null
    };
  }


}
